import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {getSelectRootElement } from "lib/DOMHelpers/retrievingDOMElems";
import Modal from 'react-modal';
import Loading from './LoadingView';
import Close from 'react-icons/lib/md/close';
import * as CustomClassUtilities from "lib/CustomClassUtilities";

import './ResultsModal.less';

class ResultsModal extends Component {

	constructor() {
		super();
		this.setAppElement = this.setAppElement.bind(this);
	}

	//Set the app element to allow screenreaders to work with the modal. When the parent element is set, the app element should
	//not be a parent of the modal, to prevent modal content from being hidden to screenreaders when it is open.
	setAppElement(parentElement) {
		if (parentElement && parentElement.children.length > 0) {
			Modal.setAppElement(parentElement);
		}
	}
	render() {
		//Set the app element for accessibility (enables use with screen readers)
		this.setAppElement(getSelectRootElement ());

		let contentStyle = { 'overflowY': 'hidden' };

		if (this.props.isScrollable) {
			contentStyle.overflowY = 'auto';
		}

		var collection = document.getElementsByClassName('novselect-app extra-classy main-app');
		document.documentElement.style.setProperty(`--z-index-for-novelist-modal`, CustomClassUtilities.getZIndexFromNode(collection[0], 9999, 1000));

		return (
			<Modal
				isOpen={this.props.isOpen}
				contentLabel='novSelect Modal'
				portalClassName='novselect-app extra-classy nov-modal-portal'
				className='nov-modal'
				overlayClassName='nov-overlay'
				bodyOpenClassName='nov-document-body'
				onRequestClose={this.props.close}
			>
				<div className='nov-modal-header'>
					<span>{this.props.modalTitle}</span>
					<span className='nov-modal-link' onClick={this.props.close} title='Close'><Close /></span>
				</div>
				<div className='nov-modal-content' style={contentStyle}>
					{this.props.isLoading && <Loading />}
					{this.props.children}
				</div>
			</Modal>
		);
	}
}

ResultsModal.propTypes = {
	children: PropTypes.object,
	close: PropTypes.func,
	isLoading: PropTypes.bool,
	isOpen: PropTypes.bool,
	isScrollable: PropTypes.bool,
	modalTitle: PropTypes.string,
};

export default ResultsModal;



// WEBPACK FOOTER //
// ./src/react/views/generic/ResultsModal.jsx